export default __webpack_public_path__ + "static/media/sampleInvestor.70dced83.png";